// utils/customHeadTexture.js

/**
 * Checks if a value is likely a base64 string instead of a username.
 */
const isBase64Texture = (value) => {
  return typeof value === "string" && value.length > 32 && /^[A-Za-z0-9+/=]+$/.test(value);
};

/**
 * Attempts to extract the texture ID from a base64-encoded string.
 */
const extractTextureIdFromBase64 = (base64) => {
  try {
    const decoded = atob(base64);
    const data = JSON.parse(decoded);

    const url =
      data?.textures?.SKIN?.url ||
      data?.textures?.CAPE?.url ||
      data?.textures?.HEAD?.url;

    if (!url) return null;

    const match = url.match(/\/([a-f0-9]{32,})$/i);
    return match ? match[1] : null;
  } catch (e) {
    return null;
  }
};

/**
 * Sanitizes a username to be safe for use in URLs.
 */
const sanitizeUsername = (name) => {
  return name.replace(/[^a-zA-Z0-9_]/g, "");
};

/**
 * Returns the mc-heads.net head URL for a given texture identifier.
 */
const getHeadTextureUrl = (identifier) => {
  return `https://mc-heads.net/head/${identifier}/64.png`;
};

/**
 * Returns the final texture object for a [head] tag value.
 * Supports both player names and base64 texture strings.
 */
export const getCustomHeadTexture = (value) => {
  if (!value || typeof value !== "string") return null;

  let identifier;

  if (isBase64Texture(value)) {
    identifier = extractTextureIdFromBase64(value);
  } else {
    identifier = sanitizeUsername(value);
  }

  if (!identifier) return null;

  return {
    url: getHeadTextureUrl(identifier),
    isHead: true,
  };
};
